import { SubItemFixture } from './SubItemFixture';

import { Button } from '@/components';
import { PartidoMiniLigaTO } from '@/types/minileagues';

export const ItemFixture = ({
  data,
  veda,
  onClick,
}: {
  data: PartidoMiniLigaTO;
  veda: boolean;
  onClick?: () => void;
}) => {
  return (
    <>
      <div className="flex flex-wrap justify-center w-full bg-white border-b-gdt-gray-6 border-b-[1px] px-7 lg:py-6 text-xs font-semibold text-gdt-gray-3 py-4">
        {data.p1 && (
          <SubItemFixture item={data.p1} local={true} score={data.ptsP1} />
        )}
        <span className="flex items-center lg:h-10 lg:w-10 h-7 font-bold text-sm lg:text-base text-gdt-status-green bg-gdt-status-green-light rounded-full px-2 lg:px-0 lg:justify-center mx-3 lg:mx-8">
          VS
        </span>
        {data.p2 && <SubItemFixture item={data.p2} score={data.ptsP2} />}
        {veda && (
          <Button
            className="w-full text-center font-bold text-xs lg:text-sm underline-offset-4 mt-2 lg:mt-4"
            type="button"
            variant="text"
            onClick={() => onClick && onClick()}
          >
            Ver equipo rival
          </Button>
        )}
      </div>
    </>
  );
};
